import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const purchases = [{
  name: 'Megan B.',
  location: 'Austin, Texas'
}, {
  name: 'Danielle M.',
  location: 'Tampa, Florida'
}, {
  name: 'Rachel S.',
  location: 'Dallas, Texas'
}, {
  name: 'Emily J.',
  location: 'Charlotte, North Carolina'
}, {
  name: 'Nicole A.',
  location: 'San Diego, California'
}, {
  name: 'Lauren K.',
  location: 'Chicago, Illinois'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(purchases[0]);
  useEffect(() => {
    const show = () => {
      setCurrent(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 6000);
    };
    const firstPopup = window.setTimeout(show, 3500);
    const interval = window.setInterval(show, 17000);
    return () => {
      window.clearTimeout(firstPopup);
      window.clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 z-50 animate-slide-in flex justify-center sm:justify-end pointer-events-none" data-id="element-184" data-mp="27gau5f7egtkm">
      <div className="bg-brand-plum border-2 border-brand-gold shadow-[0_0_18px_rgba(207,163,77,0.6)] rounded-lg px-2.5 py-2.5 pr-8 max-w-[300px] w-full relative pointer-events-auto" data-id="element-185" data-mp="1xodhs54nnvkb">
        <button onClick={() => setVisible(false)} aria-label="Close purchase notification" className="absolute top-1.5 right-1.5 text-white/60 hover:text-white" data-id="element-186" data-mp="2qdkj1bvhuz99">
          <XIcon className="w-4 h-4" data-id="element-187" data-mp="2gf4o0xtcj5uh" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-188" data-mp="2gdtkmz3tc03w">
          <div className="w-9 h-9 rounded-full bg-brand-gold flex items-center justify-center shrink-0 border border-white/50" data-id="element-189" data-mp="2cece02cngwx5">
            <ShoppingBagIcon className="w-4 h-4 text-brand-plum" data-id="element-190" data-mp="1510vlw2epprj" />
          </div>
          <div className="leading-tight" data-id="element-191" data-mp="10ye9mbsf2z29">
            <p className="font-bold text-white text-xs" data-id="element-192" data-mp="10xcpzixc548x">{current.name} from {current.location}</p>
            <p className="text-[11px] text-brand-blush font-semibold" data-id="element-193" data-mp="12gkxrppmn800">just purchased this digital book</p>
          </div>
        </div>
      </div>
    </div>;
}